@if (categoriesService$|async;as categoriesService) {
<section
  class="megamenu megamenuService"
  #megamenuService
  (mouseenter)="!isMobile && checkIsMegaMenuOnHover()"
  (mouseleave)="!isMobile && checkIsMegaMenuOnHover()"
>
  <div class="container-fluid">
    <div class="containerColumns" #megamenuColumns>
      <div class="categories" #categories>
        <div
          class="contentCategoriesItems"
          id="categoriesServiceMenu"
          (mouseenter)="!isMobile && checkIsMegaMenuOnHover()"
          (mouseleave)="!isMobile && checkIsMegaMenuOnHover()"
        >
          <div class="titleMegaMenu">
            @if (isMobile) {
            <button class="btnBackMegamenu" (click)="hideCategories()">
              <div class="contentImage">
                <img src="/general/chevron-left.svg" alt="left arrow" width="24" height="24" />
              </div>
            </button>
            <span>SERVICIOS</span>
            }
          </div>
          @for (category of categoriesService; track $index) {
          <a
            [routerLink]="'/servicio/' + category.slug"
            class="category"
            [id]="'category-' + category.slug"
            (click)="isMobile ? closeAll() : closeMegaMenu()"
          >
            {{ category.name }}
          </a>
          }
          <a
            routerLink="/servicio"
            class="category btnMegaMenu"
            (click)="isMobile ? closeAll() : closeMegaMenu()"
            >Ver todos los servicios</a
          >
        </div>
      </div>
    </div>
  </div>
</section>

<div id="gradientService"></div>
}
